import { render, staticRenderFns } from "./VisitorLevelsPermissionsField.vue?vue&type=template&id=19705127&"
import script from "./VisitorLevelsPermissionsField.vue?vue&type=script&lang=js&"
export * from "./VisitorLevelsPermissionsField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports